/**
 *Blocking method Promise overwriting by external script
 */
/* eslint-disable */
(function () {
    Object.defineProperty(window, 'Promise', {
        writable: false,
        configurable: false
    });
})();
